// Institute data for login and signup forms
export const institutes = [
  { code: 'AACH', name: 'AACH', place: 'Sirsa' },
  { code: 'AACRI', name: 'AACRI', place: 'Himachal Pradesh' },
  { code: 'AAMC', name: 'AAMC', place: 'Bangalore' },
  { code: 'AAMCH', name: 'AAMCH', place: 'Bangalore' },
  { code: 'AAMV', name: 'AAMV', place: 'Pune' },
  { code: 'ACSE', name: 'ACSE', place: 'Pune' },
  { code: 'AIAMH', name: 'AIAMH', place: 'Mirzapur' },
  { code: 'ALRCA', name: 'ALRCA', place: 'Chennai' },
  { code: 'AMC', name: 'AMC', place: 'Kolhapur' },
  { code: 'AMH', name: 'AMH', place: 'Old Hubli' },
  { code: 'APMAM', name: 'APMAM', place: 'Sion Mumbai' },
  { code: 'ARAC', name: 'ARAC', place: 'Pune' },
  { code: 'ASSAMV', name: 'ASSAMV', place: 'Nashik' },
  { code: 'AIIA', name: 'AIIA', place: 'Delhi' },
  { code: 'AUTCH', name: 'AUTCH', place: 'Delhi' },
  { code: 'BGACH', name: 'BGACH', place: 'Jhansi' },
  { code: 'CBPACS', name: 'CBPACS', place: 'Delhi' },
  { code: 'DMMA', name: 'DMMA', place: 'Yavatmal' },
  { code: 'DRNRSGAC', name: 'DRNRSGAC', place: 'Vijayawada' },
  { code: 'FAUAU', name: 'FAUAU', place: 'Dehradun' },
  { code: 'GAAMC', name: 'GAAMC', place: 'Ahmedabad' },
  { code: 'GAAMV', name: 'GAAMV', place: 'Indore' },
  { code: 'GAC', name: 'GAC', place: 'Guwahati' },
  { code: 'GAC', name: 'GAC', place: 'Rewa' },
  { code: 'GAC', name: 'GAC', place: 'Jabalpur' },
  { code: 'GAC', name: 'GAC', place: 'Balangir' },
  { code: 'GAC', name: 'GAC', place: 'Nanded' },
  { code: 'GAC', name: 'GAC', place: 'Kannur' },
  { code: 'GAC', name: 'GAC', place: 'Vadodara' },
  { code: 'GAC', name: 'GAC', place: 'Thiruvananthapuram' },
  { code: 'GAC', name: 'GAC', place: 'Ernakulam' },
  { code: 'GAC', name: 'GAC', place: 'Gwalior' },
  { code: 'GAC', name: 'GAC', place: 'Jalgaon' },
  { code: 'GAC', name: 'GAC', place: 'Banda' },
  { code: 'GAC', name: 'GAC', place: 'Bilaspur' },
  { code: 'GAC', name: 'GAC', place: 'Patna' },
  { code: 'GAC', name: 'GAC', place: 'Varanasi' },
  { code: 'GAC', name: 'GAC', place: 'Puri' },
  { code: 'GAC', name: 'GAC', place: 'Osmanabad' },
  { code: 'GAC', name: 'GAC', place: 'Patiala' },
  { code: 'GAC', name: 'GAC', place: 'Haridwar' },
  { code: 'GAC', name: 'GAC', place: 'Junagadh' },
  { code: 'GAC', name: 'GAC', place: 'Lucknow' },
  { code: 'GAC', name: 'GAC', place: 'Nagercoil' },
  { code: 'GAC', name: 'GAC', place: 'Mysore' },
  { code: 'GAC', name: 'GAC', place: 'Shimoga' },
  { code: 'GAC', name: 'GAC', place: 'Nagpur' },
  { code: 'GAC', name: 'GAC', place: 'Ujjain' },
  { code: 'GAC', name: 'GAC', place: 'Kolkata' },
  { code: 'GAC', name: 'GAC', place: 'Ganjam' },
  { code: 'GAC', name: 'GAC', place: 'Boradi' },
  { code: 'GAC', name: 'GAC', place: 'Pilibhit' },
  { code: 'GAC', name: 'GAC', place: 'Udaipur' },
  { code: 'GACH', name: 'GACH', place: 'Kannur' },
  { code: 'GACH', name: 'GACH', place: 'Vadodara' },
  { code: 'GACH', name: 'GACH', place: 'Thiruvananthapuram' },
  { code: 'GACH', name: 'GACH', place: 'Ernakulam' },
  { code: 'GAM', name: 'GAM', place: 'Kannur' },
  { code: 'GAMC', name: 'GAMC', place: 'Kannur' },
  { code: 'GAMC', name: 'GAMC', place: 'Vadodara' },
  { code: 'GAMCH', name: 'GAMCH', place: 'Kannur' },
  { code: 'GAMCH', name: 'GAMCH', place: 'Vadodara' },
  { code: 'GAMCTH', name: 'GAMCTH', place: 'Kannur' },
  { code: 'GAMV', name: 'GAMV', place: 'Kannur' },
  { code: 'GDAC', name: 'GDAC', place: 'Kannur' },
  { code: 'JBRSAMC', name: 'JBRSAMC', place: 'Kannur' },
  { code: 'KAMC', name: 'KAMC', place: 'Kannur' },
  { code: 'KVTRAC', name: 'KVTRAC', place: 'Kannur' },
  { code: 'LHSPGAC', name: 'LHSPGAC', place: 'Kannur' },
  { code: 'MMMGAC', name: 'MMMGAC', place: 'Kannur' },
  { code: 'NEIAH', name: 'NEIAH', place: 'Shillong' },
  { code: 'NIA', name: 'NIA', place: 'Jaipur' },
  { code: 'PKSGAC', name: 'PKSGAC', place: 'Bhopal' },
  { code: 'PSSGACH', name: 'PSSGACH', place: 'Burhanpur' },
  { code: 'RAPAMC', name: 'RAPAMC', place: 'Mumbai' },
  { code: 'RASACH', name: 'RASACH', place: 'Begusarai' },
  { code: 'RGAMCH', name: 'RGAMCH', place: 'Puducherry' },
  { code: 'RGPGA', name: 'RGPGA', place: 'Haridwar' },
  { code: 'RGPGAC', name: 'RGPGAC', place: 'Paprola' },
  { code: 'RJVSBSAMV', name: 'RJVSBSAMV', place: 'Sawantwadi' },
  { code: 'RTAM', name: 'RTAM', place: 'Akola' },
  { code: 'SAM', name: 'SAM', place: 'Nagpur' },
  { code: 'SCMAVM', name: 'SCMAVM', place: 'Satara' },
  { code: 'SGAM', name: 'SGAM', place: 'Amravati' },
  { code: 'SGKAM', name: 'SGKAM', place: 'Jamnagar' },
  { code: 'SGRAM', name: 'SGRAM', place: 'Ahmednagar' },
  { code: 'SGSGAM', name: 'SGSGAM', place: 'Ahmednagar' },
  { code: 'SJPMAMC', name: 'SJPMAMC', place: 'Bhavnagar' },
  { code: 'SKGACH', name: 'SKGACH', place: 'Kurukshetra' },
  { code: 'SKGMAC', name: 'SKGMAC', place: 'Muzaffarnagar' },
  { code: 'SLBSSGACH', name: 'SLBSSGACH', place: 'Prayagraj' },
  { code: 'SMIMS', name: 'SMIMS', place: 'Sonipat' },
  { code: 'SNAAMV', name: 'SNAAMV', place: 'Surat' },
  { code: 'SNPAAC', name: 'SNPAAC', place: 'Raipur' },
  { code: 'SRMGACH', name: 'SRMGACH', place: 'Bareilly' },
  { code: 'TAMV', name: 'TAMV', place: 'Pune' },
  { code: 'TGAMC', name: 'TGAMC', place: 'Ballari' },
  { code: 'UCA', name: 'UCA', place: 'Jodhpur' },
  { code: 'VAM', name: 'VAM', place: 'Amravati' },
  { code: 'VDPAMC', name: 'VDPAMC', place: 'Sangli' },
  { code: 'VPVAC', name: 'VPVAC', place: 'Kottakkal' },
  { code: 'VRAC', name: 'VRAC', place: 'Thrissur' }
];

// Helper function to get display text for institute
export const getInstituteDisplayText = (institute) => {
  if (!institute) return '';
  return `${institute.code} - ${institute.place}`;
};

// Helper function to find institute by code and place
export const findInstitute = (code, place) => {
  return institutes.find(inst => inst.code === code && inst.place === place);
};
